import React from "react";
import { createRoot } from "react-dom/client";
import "../styles/globals.css";
import { TaskPane } from "../components/TaskPane";

// Catch unhandled errors that would silently crash the WebView
window.onerror = (message, source, lineno, colno, error) => {
  console.error("Unhandled error:", message, source, lineno, colno, error);
};
window.onunhandledrejection = (event) => {
  console.error("Unhandled promise rejection:", event.reason);
};

Office.onReady(() => {
  const container = document.getElementById("root");
  if (container) {
    const root = createRoot(container);
    root.render(<TaskPane />);
  }
});
